import {
  AUTH_IDENTIFY_SUCCESS,
  SET_CLIENT_INDEX,
} from "../constants/ActionTypes";

const initialState = {
  identity: {},
  clientIndex: 0,
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case AUTH_IDENTIFY_SUCCESS:
      return Object.assign({}, state, {
        identity: action.data,
      });

    case SET_CLIENT_INDEX:
      return Object.assign({}, state, {
        clientIndex: action.index,
      });

    default:
      return state;
  }
}
